import React, { Component } from 'react';
export default class ContactUs extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="contact">
          <div className="row section-head">
            <div className="ten columns">
              <p className="lead">
              Neem gerust contact op voor opdrachten of advies via onderstaande gegevens.
              </p>
            </div>
          </div>
          <div className="row">
            <aside className="eigth columns footer-widgets">
              <div className="widget">
                <h4>Email: <u>aktas-20.ha@hotmail.com</u></h4>
                <h4>Telefoonnummer: <u>+31 6 48099854</u></h4>
              </div>
            </aside>
          </div>
        </section>
        );
  }
}